import ActivateAccount from './views/loggedOut/ActivateAccount.vue'
import Contact from './views/Contact.vue'
import EditReport from "@/views/loggedIn/EditReport";
import Feedback from './views/Feedback.vue'
import HardwareRequirements from './views/HardwareRequirements.vue'
import Home from './views/Home.vue'
import List from "@/views/loggedIn/List";
import Login from './views/loggedOut/Login.vue'
import Logout from './views/loggedIn/Logout.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import Reference from './views/loggedIn/Reference.vue'
import Register from './views/loggedOut/Register.vue'
import Regulations from './views/Regulations.vue'
import Report from './views/loggedIn/Report.vue'
import Reports from './views/loggedIn/Reports.vue'
import ResetPassword from './views/loggedOut/ResetPassword.vue'
import Router from 'vue-router'
import ShowReport from './views/loggedIn/ShowReport.vue'
import ShowReportMessages from './views/loggedIn/ShowReportMessages.vue'
import Vue from 'vue'
import store from './store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}
const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    next('/zaloguj-sie')
}
const ifConsultant = (to, from, next) => {
    if (store.getters.isAuthenticated && (store.getters.getUserData.is_consultant || store.getters.getUserData.is_admin)) {
        next()
        return
    }
    next(from)
}
const ifReporter = (to, from, next) => {
    if (store.getters.isAuthenticated && (store.getters.getUserData.is_doctor || store.getters.getUserData.is_admin)) {
        next()
        return
    }
    next(from)
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/kontakt',
            name: 'contact',
            component: Contact,
        },
        {
            path: '/wymagania-sprzetowe',
            name: 'hardwareRequirements',
            component: HardwareRequirements,
        },
        {
            path: '/bledy-i-sugestie',
            name: 'feedback',
            component: Feedback,
        },
        {
            path: '/polityka-prywatnosci',
            name: 'privacyPolicy',
            component: PrivacyPolicy,
        },
        {
            path: '/regulamin',
            name: 'regulations',
            component: Regulations,
        },
        {
            path: '/zaloguj-sie',
            name: 'login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/aktywuj-konto/:doctorId',
            name: 'activateAccount',
            component: ActivateAccount,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/resetuj-haslo/:id',
            name: 'resetPassword',
            component: ResetPassword,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/rejestracja',
            name: 'register',
            component: Register,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/zgloszenia',
            name: 'reports',
            component: Reports,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/tabela-zgloszen',
            name: 'list',
            component: List,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/osrodek-referencyjny',
            name: 'reference',
            component: Reference,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/zglos-przypadek',
            name: 'report',
            component: Report,
            beforeEnter: ifReporter
        },
        {
            path: '/zgloszenie/:id/konsultacja',
            name: 'reportEdit',
            component: EditReport,
            beforeEnter: ifConsultant
        },
        {
            path: '/zgloszenie/:id',
            name: 'reportShow',
            component: ShowReport,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/zgloszenie/:id/wiadomosci',
            name: 'reportShow',
            component: ShowReportMessages,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/wyloguj-sie',
            name: 'logout',
            component: Logout,
            beforeEnter: ifAuthenticated
        },
    ]
})
